module.exports = __webpack_public_path__ + "static/media/input-icon-building~bfBfexsf.19725578.svg";